// 判断图片路径是否有效
export const checkImgExists = (imgurl) => {
  return new Promise((resolve, reject) => {
    const ImgObj = new Image()
    ImgObj.src = imgurl
    ImgObj.onload = res => {
      resolve(res)
    }
    ImgObj.onerror = err => {
      reject(err)
    }
  })
}

// 获取地址栏指定参数的值
export const getUrlParam = (paramName) => {
  // 获取url中跟在问号后面的部分
  const params = window.location.search
  // 检测参数是否存在
  if (params.indexOf(paramName) > -1) {
    let paramValue = ''
    paramValue = params.substring(params.indexOf(paramName), params.length)
    // 检测后面是否还有参数
    if (paramValue.indexOf('&') > -1) {
      // 去除后面多余的参数, 得到最终 paramName=paramValue 形式的值
      paramValue = paramValue.substring(0, paramValue.indexOf('&'))
      // 去掉参数名, 得到最终纯值字符串
      paramValue = paramValue.replace(paramName + '=', '')
      return paramValue
    } else {
      paramValue = paramValue.replace(paramName + '=', '')
      return paramValue
    }
  }
}

// 使用canvas压缩图片
export const compress = (img, Orientation) => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const tCanvas = document.createElement('canvas')
  const tctx = tCanvas.getContext('2d')
  let width = img.width
  let height = img.height
  // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
  let ratio
  if ((ratio = (width * height) / 4000000) > 1) {
    // console.log("大于400万像素");
    ratio = Math.sqrt(ratio)
    width /= ratio
    height /= ratio
  } else {
    ratio = 1
  }
  canvas.width = width
  canvas.height = height
  //    铺底色
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  // 如果图片像素大于100万则使用瓦片绘制
  let count
  if ((count = (width * height) / 1000000) > 1) {
    // console.log("超过100W像素");
    count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片
    //      计算每块瓦片的宽和高
    const nw = ~~(width / count)
    const nh = ~~(height / count)
    tCanvas.width = nw
    tCanvas.height = nh
    for (let i = 0; i < count; i++) {
      for (let j = 0; j < count; j++) {
        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
      }
    }
  } else {
    ctx.drawImage(img, 0, 0, width, height)
  }
  // 修复ios上传图片的时候 被旋转的问题
  if (Orientation != '' && Orientation != 1) {
    switch (Orientation) {
      case 6: // 需要顺时针（向左）90度旋转
        rotateImg(img, 'left', canvas)
        break
      case 8: // 需要逆时针（向右）90度旋转
        rotateImg(img, 'right', canvas)
        break
      case 3: // 需要180度旋转
        rotateImg(img, 'right', canvas) // 转两次
        rotateImg(img, 'right', canvas)
        break
    }
  }
  // 进行最小压缩
  const ndata = canvas.toDataURL('image/jpeg', 0.1)
  tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
  return ndata
}

// 旋转图片
export const rotateImg = (img, direction, canvas) => {
  // 最小与最大旋转方向，图片旋转4次后回到原方向
  const min_step = 0
  const max_step = 3
  if (img == null) return
  // img的高度和宽度不能在img元素隐藏后获取，否则会出错
  const height = img.height
  const width = img.width
  let step = 2
  if (step == null) {
    step = min_step
  }
  if (direction == 'right') {
    step++
    // 旋转到原位置，即超过最大值
    step > max_step && (step = min_step)
  } else {
    step--
    step < min_step && (step = max_step)
  }
  // 旋转角度以弧度值为参数
  const degree = (step * 90 * Math.PI) / 180
  const ctx = canvas.getContext('2d')
  switch (step) {
    case 0:
      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0)
      break
    case 1:
      canvas.width = height
      canvas.height = width
      ctx.rotate(degree)
      ctx.drawImage(img, 0, -height)
      break
    case 2:
      canvas.width = width
      canvas.height = height
      ctx.rotate(degree)
      ctx.drawImage(img, -width, -height)
      break
    case 3:
      canvas.width = height
      canvas.height = width
      ctx.rotate(degree)
      ctx.drawImage(img, -width, 0)
      break
  }
}

// 将base64转换为文件
export const dataURLtoFile = (dataurl, files) => {
  const arr = dataurl.split(',')
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], files.name, {
    type: files.type
  })
}

// 原理：在规定的时间内没有再次触发，被判定为有效
// debounce(函数名, 防抖时间, true)  防抖
let timeout = null
export const debounce = (func, wait = 500, immediate = false) => {
  // 清除定时器
  if (timeout !== null) clearTimeout(timeout)
  // 立即执行，此类情况一般用不到
  if (immediate) {
    var callNow = !timeout
    timeout = setTimeout(function () {
      timeout = null
    }, wait)
    if (callNow) typeof func === 'function' && func()
  } else {
    // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
    timeout = setTimeout(function () {
      typeof func === 'function' && func()
    }, wait)
  }
}

// 原理：规定的时间内只能触发一次 节流
export const throttle = (func, wait) => {
  let context, args
  let previous = 0
  return () => {
    // 当前时间戳
    const now = +new Date() // 相当于 let now = new Date().getTime()
    context = this
    args = arguments
    // 当前的时间戳 - 之前的时间戳
    if (now - previous > wait) {
      func.apply(context, args)
      previous = now
    }
  }
}

// 根据项目名称生成岗位技能与条件描述
export const generateDescriptionByName = (name) => {
  const n = String(name || '').trim()
  if (!n) {
    return '基本要求：责任心强，具备沟通协作能力，能按时保质完成任务。'
  }
  const rules = [
    { keywords: ['市场推广', '推广', '营销', '市场'], desc: '要求：熟悉线上线下渠道投放，具备数据分析与ROI意识，能撰写活动文案并协调素材制作，熟练使用Excel/统计工具，沟通与执行力强。' },
    { keywords: ['新媒体', '内容运营', '运营', '自媒体'], desc: '要求：具备选题策划与文案写作能力，懂排版与发布节奏，能做数据复盘与优化，熟悉平台规则与热点机制。' },
    { keywords: ['电商客服', '客服', '淘宝', '京东', '拼多多'], desc: '要求：熟悉平台规则与售前售后流程，打字与沟通能力良好，耐心细致，能处理退款/退换等问题并做好记录。' },
    { keywords: ['数据标注', '标注', 'AI', '训练数据'], desc: '要求：细致耐心，严格遵循标注规范，熟练使用标注工具，保证一致性与准确率，按时交付。' },
    { keywords: ['文案', '编辑', '写作'], desc: '要求：文案基础扎实，信息采集与重写能力强，懂基本SEO与排版规范，具备审校与自我迭代能力。' },
    { keywords: ['平面设计', 'UI', '设计', '海报'], desc: '要求：熟练使用PS/AI/Sketch等工具，版式与色彩敏感，能独立完成Banner/海报等物料，沟通理解需求并高效迭代。' },
    { keywords: ['视频剪辑', '短视频', '拍摄', 'PR', 'AE', '直播'], desc: '要求：熟悉PR/AE，具备脚本与镜头语言意识，把控节奏与转场，管理素材与输出规范，了解平台内容策略。' },
    { keywords: ['前端', '前端开发', 'Web', 'H5', 'Vue', 'React'], desc: '要求：熟悉HTML/CSS/JavaScript，掌握Vue/React等框架，能进行接口对接与调试，具备打包与基本性能优化意识。' },
    { keywords: ['后端', '后端开发', '服务端', '接口', 'Java', 'Node', 'Python'], desc: '要求：掌握至少一种后端语言（如Java/Node/Python），熟悉数据库（MySQL），能进行接口设计、权限与日志处理。' },
    { keywords: ['测试', 'QA'], desc: '要求：能编写测试用例，开展功能/接口测试，进行缺陷跟踪与复测，熟悉常用协作与缺陷管理工具。' },
    { keywords: ['产品', '产品助理', 'PM'], desc: '要求：具备需求分析与文档撰写能力，能进行竞品调研与复盘，做好会议纪要与跟进，沟通协调能力强。' },
    { keywords: ['项目管理', 'PMO', '项目'], desc: '要求：制定进度计划与里程碑，协调资源与风险控制，推动事项闭环，沟通与抗压能力佳。' },
    { keywords: ['会计', '财务', '出纳'], desc: '要求：具备基础会计知识，能做账报税与数据核对，熟练Excel与财务软件，细致严谨。' },
    { keywords: ['人力', 'HR', '人事'], desc: '要求：熟悉招聘流程与面试安排，办理入转离手续，进行人事数据统计，具备沟通协调能力。' },
    { keywords: ['销售', 'BD', '商务', '外呼'], desc: '要求：沟通表达良好，具备客户开发与跟进能力，记录CRM信息，目标导向与抗压能力强。' },
    { keywords: ['仓储', '物流', '仓库'], desc: '要求：熟悉入库/出库/盘点流程，能规范操作与记录，了解快递与运输流程，责任心强。' },
    { keywords: ['活动执行', '会务', '地推', '展会'], desc: '要求：物料准备与现场布置，协调场地与人员，执行力强，能应对现场突发与沟通配合。' },
    { keywords: ['翻译', '英语', '日语', '韩语'], desc: '要求：语种基础扎实，术语准确，具备文本排版与交付规范意识，质量与时效兼顾。' },
    { keywords: ['文员', '行政'], desc: '要求：文档处理与表格统计，会议与日常事务安排，细致可靠，具备基本办公软件使用能力。' }
  ]
  const lower = n.toLowerCase()
  for (const rule of rules) {
    if (rule.keywords.some(k => lower.includes(k.toLowerCase()))) {
      return rule.desc
    }
  }
  // 未匹配到具体岗位时给出通用描述
  return '基本要求：责任心强，具备沟通协作能力，按流程规范执行，能按时保质完成交付。'
}
